import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export default function initGsapPropertyCards() {
    // Check if desktop wrapper is visible or exists
    const section = document.querySelector('.property-cards');
    if (!section) return;

    const wrapper = section.querySelector('.property-cards__wrapper');
    // If wrapper is hidden (mobile), don't run GSAP
    if (!wrapper || getComputedStyle(wrapper).display === 'none') return;

    let cards = wrapper.querySelectorAll('.property-item__col');
    if (!cards.length) return;

    const updateHeight = () => {
        let maxHeight = 0;
        cards.forEach(card => {
            const h = card.offsetHeight;
            if (h > maxHeight) maxHeight = h;
        });
        
        if (maxHeight > 0) {
            gsap.set(wrapper, { height: maxHeight });
        }
    };

    // Initial calculation
    updateHeight();

    // Randomly scatter cards to create a stacked effect
    // And set Z-index so first ones are on top
    cards.forEach((card, i) => {
        gsap.set(card, {
            zIndex: cards.length - i
        });
    });

    // Setup Timeline
    const viewMoreCard = wrapper.querySelector('.property-cards__viewmore-card');
    const propertyCards = Array.from(cards).filter(c => c !== viewMoreCard);

    const tl = gsap.timeline({
        scrollTrigger: {
            trigger: section,
            start: "center center",
            end: "+=400%",
            pin: true,
            pinSpacing: true,
            scrub: 1,

        }
    });

    // 1. Move ALL cards from Center to Right
    tl.fromTo(cards, {
        x: (i, target) => -(wrapper.offsetWidth / 2 - target.offsetWidth / 2) + gsap.utils.random(-20, 20),
        y: () => gsap.utils.random(-20, 20),
        rotation: () => gsap.utils.random(-6, 6)
    }, {
        x: () => 0 + gsap.utils.random(-20, 20),
        y: () => gsap.utils.random(-20, 20),
        rotation: () => gsap.utils.random(-6, 6),
        duration: 1,
        ease: "power1.inOut"
    });

    // 2. Peel cards to Left / Center
    propertyCards.forEach((card, index) => {
        const isLast = index === propertyCards.length - 1;
        
        if (!isLast) {
            // Move to Left
            tl.set(card, { zIndex: 200 }) // Bring to top before moving
              .to(card, {
                x: () => -(wrapper.offsetWidth - card.offsetWidth) + gsap.utils.random(-20, 20),
                y: () => gsap.utils.random(-20, 20),
                rotation: () => gsap.utils.random(-6, 6),
                duration: 1,
                ease: "power1.inOut"
            })
            .set(card, { zIndex: index + 1 });
        } else {
            // Move to Center
            tl.set(card, { zIndex: 200 }) // Bring to top before moving
              .to(card, {
                x: () => -(wrapper.offsetWidth / 2 - card.offsetWidth / 2) + gsap.utils.random(-10, 10),
                y: () => gsap.utils.random(-10, 10),
                rotation: () => gsap.utils.random(-3, 3),
                duration: 1,
                ease: "power1.inOut"
            })
            .set(card, { zIndex: 100 });
        }
    });
    // Update on resize
    window.addEventListener('resize', updateHeight);
    
    // Update when ScrollTrigger refreshes
    ScrollTrigger.addEventListener("refreshInit", updateHeight);
}
